import React from "react";
import styles from "./Informer.module.scss";

export interface Props {
  title: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  icon?: any;
  text?: string;
  button?: {
    text: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    callback: (feedback: any) => Promise<void>;
  };
}
const Informer = (props: Props): JSX.Element => {
  const { button = null, icon = null, title, text = "" } = props;
  return (
    <div className={styles.Wrapper}>
      {icon}
      <h1>{title}</h1>
      <p>{text}</p>
      {button && <button onClick={button.callback}>{button.text}</button>}
    </div>
  );
};

export default Informer;
